import React, { useState } from 'react';
import styled from 'styled-components';
import { H1, IconLock, P, Small } from '@upsolve/ui';

import SCREENER_CTA_TYPES from '../analytics/screenerCtaTypes';
import getScreenerUrl from '../Links/getScreenerUrl';
import VideoInContext from '../Media/VideoInContext';
import withViewportWatch from '../analytics/withViewportWatch';
import trackComponentImpression from '../analytics/trackComponentImpression';
import trackComponentAction from '../analytics/trackComponentAction';
import { ButtonLink } from '../analytics/LinksWithOnClick';

const trackingProps = {
  componentName: 'CTACover',
  componentVersion: 0,
};

const CTACover = (props) => {
  const screenerUrl = getScreenerUrl({ cta: SCREENER_CTA_TYPES.CTA_COVER, contentGroup: props.contentGroup });
  const [impressionTracked, setImpressionTracked] = useState(false)
  if (props.isInViewport && !impressionTracked) {
    setImpressionTracked(true);
    props.stopWatcher();
    trackComponentImpression(trackingProps);
  }

  return (
    <CTACoverWrapper>
      <div className="cta-cover__text">
        <H1 as="h4">America's #1 free tool for bankruptcy</H1>
        <P>We never ask for your credit card. We are a nonprofit funded by donors like Harvard University and have been featured in Forbes 4 times.</P>
        <ButtonLink
          size="lg"
          href={screenerUrl}
          onClick={() => trackComponentAction({ ...trackingProps, actionId: 'ctaCover.screenerNavigation', actionMethod: 'click' })}
        >
          <b>Get Debt Help</b>
        </ButtonLink>
        <div className="cta-cover__text__login">
          <Small>
            <IconLock /> Your data is encrypted and secure. <span><a href="https://my.upsolve.org/login">Already started? <u>Sign In</u></a></span>
          </Small>
        </div>
      </div>
      <div className="cta-cover__video">
        <VideoInContext
          video={{ youtubeId: '4FCf9FC_1nI' }}
          onPlay={() => trackComponentAction({ ...trackingProps, actionId: 'ctaCover.video', actionMethod: 'play' })}
        />
      </div>
    </CTACoverWrapper>
  )
}

const CTACoverWrapper = styled.div`
  background: ${props => props.theme.colors.white[700]};
  box-shadow: inset ${props => props.theme.effects.shadow[350]};
  height: 600px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  & > div {
    margin: 0 1em 2em;
  }
  div.cta-cover__text {
    flex-grow: 1;
    max-width: 480px;
    svg {
      position: relative;
      top: 2px;
      height: 18px;
      width: 18px;
      opacity: 0.5;
    }
    .cta-cover__text__login {
      margin-top: 0.5em;
    }
    small {
      color: ${props => props.theme.colors.gray[500]};
      span a {
        width: 100%;
        line-height: 125%;
        &, &:visited, &:hover {
          color: ${props => props.theme.colors.brand[500]};
        }
      }
    }
  }
  div.cta-cover__video {
    flex-grow: 1;
    width: 480px;
    max-width: 480px;
    height: 270px;
    border-radius: 8px;
    overflow: hidden;
  }
  @media(max-width: 45em) {
    flex-direction: column;
    height: 100%;
    padding: 3em 1em 2em;
    div.cta-cover__video {
      display: none;
    }
  }
`;

export default withViewportWatch(CTACover);
